import React, { Component, Fragment } from 'react';
import {
  Container,
  Row, Col, Input, Button, Form, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import ConfirmButton from '../Modal/ConfirmButton';
class Marketing2Types extends Component {

  standardRow = (type) => {
    return (
      <Row className="adminRow pointer text-left" onClick={() => this.props.onEdit(type.TypeID)}>
        <Col md={4}>{type.Section}</Col>
        <Col md={8}>{type.Type}</Col>
      </Row>
    )
  }

  editRow = (type) => {
    return (
      <Row className="editRow adminRow">
        <Col md={8} className="text-left">
          <Form inline>
            <FormGroup className="mr-2">
              <Input
                type="select"
                name="section"
                value={this.props.editType.section}
                onChange={e => this.props.onChange(e, 'edit')}>
                  <option>Section</option>
                  <option>Call</option>
                  <option>Email</option>
                  <option>Invitation</option>
              </Input>
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                placeholder="Type"
                name="type"
                value={this.props.editType.type + ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
          </Form>
        </Col>
        <Col className="text-right col-md-4">
          <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Type">
            <FontAwesomeIcon icon={faCheck} />
          </Button>
          <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(type.TypeID)} edit="Delete Type">
            <FontAwesomeIcon icon={faTrashAlt} />
          </ConfirmButton>
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
      </Row>
    )
  }

  addRow = () => {
    return (
      <Row className="py-4 text-left align-items-bottom ">
        <Col md={9}>
          <Form inline>
            <FormGroup className="pr-2">
              Add New Type
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                type="select"
                name="section"
                value={this.props.newType.section}
                onChange={e => this.props.onChange(e)}>
                  <option>Section</option>
                  <option>Call</option>
                  <option>Email</option>
                  <option>Invitation</option>
              </Input>
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                placeholder="Type"
                name="type"
                value={this.props.newType.type + ''}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
          </Form>
        </Col>
        <Col md={3} className="text-right">
          <Button
            disabled={this.props.newType.type === '' || this.props.newType.section === 'Section'}
            color="primary"
            onClick={this.props.handleAdd}
          >Add Type</Button>
        </Col>
      </Row>
    )
  }

  render() {
    return (
      <Container className="adminContainer" fluid>
        {this.props.types.map(type => (
          <Fragment key={type.TypeID}>{this.props.editType.typeID === type.TypeID ? this.editRow(type) : this.standardRow(type)}</Fragment>
        ))}
        {this.addRow()}
      </Container>
    );

  }
}

export default Marketing2Types;